import axios from "axios";
import AuthService from "./authentication.service";
import {
  getFreshAccessToken,
  initTokenRefresh,
  isAuthEndpoint,
  refreshAccessToken,
} from "./tokenRefresh";
import { SubscriptionModal } from "../app/components/SubscriptionModal/SubscriptionModal";

const { REACT_APP_API_BASE_URL } = process.env;
const isGuestShare = process.env.REACT_APP_API_IS_GUEST;
const { REACT_APP_FILEMANAGER_API_BASE_URL } = process.env;

export const httpFile = axios.create({
  baseURL: REACT_APP_FILEMANAGER_API_BASE_URL,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});


const https = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});

let subscriptionModalOpen = false;

const bearerOf = (config) => {
  const header =
    config?.headers?.get?.("Authorization") ?? config?.headers?.Authorization;
  return typeof header === "string" ? header.replace(/^Bearer\s+/i, "") : null;
};

export const setupInterceptor = () => {
  if (!isGuestShare) initTokenRefresh();

  https.interceptors.request.use(async (config) => {
    let token = AuthService.getAccessToken();
    // The proactive timer can be throttled in a background tab, so check
    // again here rather than sending a request that is sure to 401.
    if (!isGuestShare && !isAuthEndpoint(config.url)) {
      token = await getFreshAccessToken();
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  https.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (!navigator.onLine) {
        return Promise.reject(new Error("No internet connection"));
      }

      const config = error?.config;
      if (
        error?.response?.status === 401 &&
        !isGuestShare &&
        !isAuthEndpoint(config?.url)
      ) {
        if (config && !config._authRetried) {
          config._authRetried = true;
          try {
            // Concurrent 401s share one refresh; the retry goes back through
            // the request interceptor, which attaches the new token.
            await refreshAccessToken(bearerOf(config));
            return https(config);
          } catch (refreshError) {
            if (!refreshError?.sessionEnded) {
              return Promise.reject(error.response?.data || error);
            }
          }
        }
        AuthService.endSession();
        return Promise.reject(error.response?.data || error);
      }

      if (error?.response?.status === 400) {
        handleException(error?.response?.data);
      }

      return Promise.reject(error.response?.data || error);
    }
  );
};
const handleException = (data) => {
  if (data?.Errors && !subscriptionModalOpen) {
    subscriptionModalOpen = true;

    SubscriptionModal({
      onClose: () => {
        subscriptionModalOpen = false;
      },
    });
  }
};
export default https;
